import type { ReactElement } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Toolbar from '../components/Toolbar.tsx';
import Map from '../components/map/Map.tsx';
import Stats from '../components/Stats';
import Tooltip from '../components/map/Tooltip.tsx';
import ScatterplotWithBrush from '@/components/ScatterplotWithBrush.tsx';
import Description from '@/components/Description.tsx';
import MapOptions from '@/components/MapOptions.tsx';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { useVizStore } from '@/store';
import ScatterplotVertical from '@/components/ScatterplotVertical.tsx';

export default function Explore(): ReactElement {
  const shouldUseVerticalPlot = useMediaQuery('(min-width: 992px)');
  const plotOrientation = shouldUseVerticalPlot ? 'vertical' : 'horizontal';
  const clearSelection = useVizStore((s) => s.clearSelection);

  const handleContainerClick = () => {
    // Clear selection when clicking anywhere on the page
    // Polygon clicks stop propagation, so they won't trigger this
    // Plot point clicks also stop propagation, so they won't trigger this
    clearSelection();
  };

  return (
    <Container className="py-4" onClick={handleContainerClick}>
      {/* Toolbar row */}
      <Row className="mb-3 align-items-stretch">
        <Col>
          <Toolbar />
        </Col>
      </Row>

      {/* Description row - spans full width below both cards */}
      <Row className="mb-3">
        <Col>
          <Description open={true} />
        </Col>
      </Row>

      {/* Stats row */}
      <Row className="mb-3">
        <Col>
          <Stats />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col>
          <MapOptions />
        </Col>
      </Row>
      {/* Map & Plot row */}
      <Row
        className={`mb-3 ${shouldUseVerticalPlot ? 'd-flex align-items-stretch' : ''}`}
        style={shouldUseVerticalPlot ? { minHeight: '620px' } : undefined}
      >
        <Col xs={12} lg={9} className={`mb-3 mb-lg-0 ${shouldUseVerticalPlot ? 'd-flex' : ''}`}>
          {/* Map renders the SVG layers */}
          <Map />
          {/* Tooltip renders a floating HTML tooltip driven by vizStore hover state */}
          <Tooltip />
        </Col>
        <Col xs={12} lg={3} className={shouldUseVerticalPlot ? 'd-flex' : ''}>
          {plotOrientation === 'horizontal' && <ScatterplotWithBrush />}
          {plotOrientation === 'vertical' && <ScatterplotVertical />}{' '}
          {/*orientation={plotOrientation}  */}
        </Col>
      </Row>
    </Container>
  );
}
